/* istanbul ignore file */
import React from 'react';
import PropTypes from 'prop-types';
import { faBattery, faBatteryLow, faPlug } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import RssiDisplay from './RssiDisplay';

function getBatteryLevel(batteryLevel) {
  if (batteryLevel <= 30) return 'Low';
  if (batteryLevel <= 60) return 'Ok';
  return 'Good';
}

const CardStatusBar = ({
  rssi = 0,
  isWireless = false,
  isHub = false,
  batteryLevel = 0,
  generalAlerts = [],
  isPluggedIn = false,
}) => {
  const hasGeneralAlerts = generalAlerts.length > 0;

  const getBatteryAlert = () => {
    if (hasGeneralAlerts) {
      return generalAlerts.find((alert) => alert.type === 'battery' && alert.isTriggered);
    }
    return false;
  };

  const batteryAlertTriggered = !!getBatteryAlert();

  return (
    <div
      className="px-0"
      style={{
        backgroundColor: '#585858',
        color: '#fff',
        fontSize: '0.75rem',
        textAlign: 'center',
        display: 'inline-block',
        minWidth: '50%',
      }}
    >
      {isHub || !isWireless ? (
        <span>
          {'\u00A0'}
        </span>
      ) : (
        <div
          style={{
            display: 'flex',
          }}
        >
          {/* First Section */}
          <div
            style={{
              flex: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <RssiDisplay rssi={rssi} />
          </div>

          {/* Middle Section */}
          <div
            style={{
              flex: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <span>{' '}</span>
          </div>

          {/* Third Section */}
          <div
            style={{
              flex: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: (batteryAlertTriggered && !isPluggedIn) ? 'rgb(238, 53, 36)' : '',
            }}
          >
            {
                            isPluggedIn
                              ? (
                                <FontAwesomeIcon
                                  icon={faPlug}
                                  size="lg"
                                  style={{ color: 'white', marginRight: '-2rem' }}
                                />
                              )
                              : (
                                <>
                                  <FontAwesomeIcon
                                    icon={getBatteryLevel(batteryLevel) === 'Low' ? faBatteryLow : faBattery}
                                    size="lg"
                                    style={{ color: 'white', marginRight: '0.2rem' }}
                                  />
                                  <span>{getBatteryLevel(batteryLevel)}</span>
                                </>
                              )
                        }

          </div>
        </div>
      )}
    </div>
  );
};

CardStatusBar.defaultProps = {
  rssi: 0,
  batteryLevel: 0,
  generalAlerts: [],
  isPluggedIn: false,
  isWireless: false,
  isHub: false,
};

CardStatusBar.propTypes = {
  rssi: PropTypes.number,
  isWireless: PropTypes.bool,
  isHub: PropTypes.bool,
  batteryLevel: PropTypes.number,
  generalAlerts: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string,
    isTriggered: PropTypes.bool,
  })),
  isPluggedIn: PropTypes.bool,
};

export default CardStatusBar;
